<template>
  <div>
    <div
      v-if="status === 'loading'"
      class="text-xs-center"
    >
      <div class="progress">
        <div class="indeterminate"></div>
      </div>
    </div>

    <div
      v-else-if="status === 'error'"
    >
      <div class="card-panel red white-text">
        <i class="material-icons" style="vertical-align:middle;">error</i>
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',

  props: ['status', 'errorMessage']
}
</script>
